const TOGGLE_LOADING = 'TOGGLE_LOADING';
const HIDE_LOADING = 'HIDE_LOADING';
export { TOGGLE_LOADING, HIDE_LOADING };
